import { InjectionToken } from '@angular/core';

export const SITES_META_REDUCER_TOKEN = new InjectionToken(
  'SITES_META_REDUCER_TOKEN',
);

export const SITES_STORAGE_KEY_TOKEN = new InjectionToken(
  'SITES_STORAGE_KEY_TOKEN',
);

export const SITES_STORAGE_KEYS_TO_SAVE_TOKEN = new InjectionToken(
  'SITES_STORAGE_KEYS_TO_SAVE_TOKEN',
);

export const sitesFeatureKey = 'sites';
